const showActionLogsReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default showActionLogsReducer;